import React from "react";
import PhoneInput from "react-phone-input-2";
import { TextField } from "@mui/material";
import "react-phone-input-2/lib/style.css";

function PhoneField(props) {
  const { value, defaultCountry, onChange, disabled } = props;

  return (
    <PhoneInput
      value={value}
      defaultCountry={defaultCountry}
      onChange={onChange}
      containerStyle={{width: 'max-content'}}
      inputStyle={{height: '3.5rem', width: '18rem'}}
      dropdownStyle={{overflow: '12'}}
      disabled={disabled}
    />
  );
}

export default PhoneField;
